import { render } from "./FooterTile.vue?vue&type=template&id=b938c0e0"
import script from "./FooterTile.vue?vue&type=script&lang=js"
export * from "./FooterTile.vue?vue&type=script&lang=js"

import "./FooterTile.vue?vue&type=style&index=0&id=b938c0e0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__